import moment from 'moment';
import ms from 'ms';

const MONTH_NAMES = moment.months();
const [sun, ...monsat] = moment.weekdaysShort().map((d) => d.toLowerCase());
const days = [...monsat, sun];

const HELPER = {

  getTimeStopSinceTimestamp: (timestamp: number) => {
    const hoursSince = moment().diff(timestamp, 'hours');
    const minutesSince = moment().diff(timestamp, 'minutes');
    const secondsSince = moment().diff(timestamp, 'seconds');

    return {
      hours: hoursSince,
      minutes: minutesSince,
      seconds: secondsSince,
      timeStop: ms(Date.now() - timestamp),
    };
  },

  getMonthLabel: (month:number) => MONTH_NAMES[month - 1],

  zeroPad: (num: number) => (`00${num}`).substr(-2, 2),

  clip: (num: number, min: number, max: number) => (
    Math.max(min, Math.min(num, max))
  ),

  getMinute: (num: number) => HELPER.clip(num % 100, 0, 60),

  getHour: (num: number) => HELPER.clip(Math.floor(num / 100), 0, 24),

  millesecondsSince: (timestamp: number) => moment().valueOf() - timestamp,

  prettyPrint: (hour: number) => (
    `${HELPER.zeroPad(HELPER.getHour(hour))}:${HELPER.zeroPad(HELPER.getMinute(hour))}`
  ),

  prettyPrintMinutes: (minutes: number) => {
    const fullHours = HELPER.zeroPad(Math.floor(minutes / 60));
    const partialHours = HELPER.zeroPad(minutes % 60);
    const hour = Number(`${fullHours}${partialHours}`);
    return HELPER.prettyPrint(hour);
  },

  days,

  MONTH_NAMES,

  formatSeconds: (responseTime = 0) => {
    if (responseTime < 100) {
      return `${responseTime.toFixed(0)}s`;
    }
    return moment()
      .startOf('day')
      .seconds(Number(responseTime.toFixed(0)))
      .format('m[m]ss');
  },
};

export default HELPER;
